import React from "react";
import Header from "../Header/Header.tsx";
import Footer from "../Footer/Footer.tsx";
import { coupleroom } from "../../Assets.tsx";
import { useHistory } from "react-router-dom";
import CommonBtn from "../CommonComponent/CommonBtn.tsx";

const Coupleroom = () => {
  const history = useHistory();
  const webstyle = {
    Container: {
      width: "100%",
      height: "auto",
      Top:"80px"
    },
    BannerImage: {
      width: "100%",
      height: "90vh",
    },
  };
  return (
    <>
      <Header />
      <div style={{ ...webstyle.Container, position: "relative",top:"10px" }}>
        <img style={webstyle.BannerImage} src={coupleroom} alt="Couple Room" />

        <div
          style={{
            width: "80%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <a
            href="#Amenities"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none" }}
          >
            <button
              style={{
                display: "flex",
                alignSelf: "start",
                padding: "10px",
                backgroundColor: "black",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "30px",
                marginBottom: "5px",
              }}
            >
              Back
            </button>
          </a>
          <h1 style={{ fontSize: "50px", color: "white" }}>Couple Room</h1>
              <CommonBtn/>
        </div>
      </div>

      <Footer/>
    </>
  );
};

export default Coupleroom;
